import { createAction, props } from '@ngrx/store';
import {County} from '../../core/classes/county';
import { Territory } from '../../core/classes/territory';



export const LoadTerritoryDataSuccess = createAction(
  '[Location] Load State Data Success',
  props<{territories: Territory[]}>(),
);

export const LoadCountyDataSuccess = createAction(
  '[Location] Load County Data Success',
  props<{counties: County[]}>(),
);
